import React from 'react';
import { View, Text, StyleSheet, Dimensions } from 'react-native';
import { User } from 'oidc-client-ts';
import BlankModal from './BlankModal';
import { getResponsivePadding, getResponsiveFontSize } from '../../helpers/utils';

const { width } = Dimensions.get('window');

interface WalletRequestConfirmModalProps {
  isVisible: boolean;
  user: User | null | undefined;
  onConfirm: () => void;
  onReject: () => void;
}

const WalletRequestConfirmModal: React.FC<WalletRequestConfirmModalProps> = ({
  isVisible,
  user,
  onConfirm,
  onReject
}) => {
  return (
    <BlankModal
      isVisible={isVisible}
      onClose={onReject}
      onConfirm={onConfirm}
      title="Confirm Wallet Request"
      acceptText="Confirm">
      <View style={styles.modalContent}>
        <Text style={styles.modalText}>
          Please confirm your details to proceed with the wallet request:
        </Text>

        <View style={styles.userInfoContainer}>
          <View style={styles.userInfoRow}>
            <Text style={styles.userInfoLabel}>Name:</Text>
            <Text style={styles.userInfoValue}>
              {user?.profile.name || user?.profile.given_name || 'Not available'}
            </Text>
          </View>

          <View style={styles.userInfoRow}>
            <Text style={styles.userInfoLabel}>Email:</Text>
            <Text style={styles.userInfoValue}>{user?.profile.email || 'Not available'}</Text>
          </View>
        </View>

        <Text style={styles.modalWarning}>
          By confirming, you will be requesting a wallet to complete the wallet setup process.
        </Text>
      </View>
    </BlankModal>
  );
};

const styles = StyleSheet.create({
  modalContent: {
    alignItems: 'flex-start',
    width: '100%'
  },
  modalText: {
    fontSize: getResponsiveFontSize(14, 15, 16),
    color: '#4B5563',
    marginBottom: getResponsivePadding(16, 18, 20),
    lineHeight: getResponsiveFontSize(20, 22, 24),
    width: '100%'
  },
  userInfoContainer: {
    backgroundColor: '#F9FAFB',
    padding: getResponsivePadding(12, 14, 16),
    borderRadius: 8,
    width: '100%',
    marginBottom: getResponsivePadding(12, 14, 16),
    borderWidth: 1,
    borderColor: '#E5E7EB',
    overflow: 'hidden'
  },
  userInfoRow: {
    flexDirection: width < 400 ? 'column' : 'row',
    marginBottom: getResponsivePadding(6, 7, 8),
    alignItems: 'flex-start'
  },
  userInfoLabel: {
    fontSize: getResponsiveFontSize(12, 13, 14),
    fontWeight: '600',
    color: '#374151',
    minWidth: width < 400 ? 'auto' : 60,
    marginRight: width < 400 ? 0 : 12,
    marginBottom: width < 400 ? 4 : 0
  },
  userInfoValue: {
    fontSize: getResponsiveFontSize(12, 13, 14),
    color: '#1F2937',
    flex: 1,
    flexWrap: 'wrap'
  },
  modalWarning: {
    fontSize: getResponsiveFontSize(12, 13, 14),
    color: '#6B7280',
    fontStyle: 'italic',
    lineHeight: getResponsiveFontSize(16, 18, 20),
    width: '100%'
  }
});

export default WalletRequestConfirmModal;
